import api from './api';

const issueService = {
  // Get all issues with filtering and pagination
  getAll: async (params = {}) => {
    const response = await api.get('/issues', { params });
    return response.data;
  },

  // Get issue by ID
  getById: async (id) => {
    const response = await api.get(`/issues/${id}`);
    return response.data;
  },

  // Get issues by project
  getByProject: async (projectId, params = {}) => {
    const response = await api.get(`/issues/project/${projectId}`, { params });
    return response.data;
  },

  // Get issue statistics
  getStatistics: async (projectId = null) => {
    const params = projectId ? { project_id: projectId } : {};
    const response = await api.get('/issues/statistics', { params });
    return response.data;
  },

  // Create new issue
  create: async (issueData) => {
    const response = await api.post('/issues', issueData);
    return response.data;
  },

  // Update issue
  update: async (id, issueData) => {
    const response = await api.put(`/issues/${id}`, issueData);
    return response.data;
  },

  // Delete issue
  delete: async (id) => {
    const response = await api.delete(`/issues/${id}`);
    return response.data;
  },

  // Helper: Get issue type options
  getIssueTypes: () => ['Bug', 'Blocker', 'Question', 'Improvement'],

  // Helper: Get severity options
  getSeverities: () => ['Low', 'Medium', 'High', 'Critical'],

  // Helper: Get status options
  getStatuses: () => ['Open', 'In Progress', 'Resolved', 'Closed'],

  // Helper: Get severity color
  getSeverityColor: (severity) => {
 const colors = {
  'Low': 'badge badge-info',
  'Medium': 'badge badge-warning',
  'High': 'badge badge-primary',
  'Critical': 'badge badge-danger'
};

return colors[severity] || 'badge badge-secondary';
  },

  // Helper: Get status color
      getStatusColor: (status) => {
    const colors = {
      'Open': 'badge badge-info',
      'In Progress': 'badge badge-warning',
      'Resolved': 'badge badge-success',
      'Closed': 'badge badge-secondary'
    };

    return colors[status] || 'badge badge-secondary';
      },

  // Helper: Get issue type icon
  getIssueTypeIcon: (type) => {
    const icons = {
      'Bug': '🐛',
      'Blocker': '🚫',
      'Question': '❓',
      'Improvement': '✨'
    };
    return icons[type] || '📝';
  }
};

export default issueService;


